import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonPage,
  IonRadio,
  IonRadioGroup,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {
  chevronDownOutline,
  filterCircleOutline,
  filterCircleSharp,
} from "ionicons/icons";
import React, { useState } from "react";
import { ValidValue } from "../models/common/ValidValue";

type Props = {
  value?: string | number | null;
  title: string;
  options: ValidValue[];
  onSelect: (value: any) => void;
  filterPlaceholder?: string;
};

const DropdownElement: React.FC<Props> = ({
  value,
  title,
  options,
  filterPlaceholder = "Filter",
  onSelect,
}) => {
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [selected, setSelected] = useState(value);

  return (
    <React.Fragment>
      <IonItem
        class="dropdown-item"
        onClick={() => {
          setShowEmployeeModal(true);
        }}
      >
        <IonLabel slot="start" className="align-value">
          {value}
        </IonLabel>
        <IonIcon
          icon={chevronDownOutline}
          className="dropdown-icon"
          slot="end"
        />
      </IonItem>
      <IonModal isOpen={showEmployeeModal}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>{title}</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setShowEmployeeModal(false)}>
                Close
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonItem>
            <IonInput
              placeholder={filterPlaceholder}
              onIonChange={(e) => setFilter(e.detail.value!)}
              value={filter}
            ></IonInput>
            <IonIcon
              slot="end"
              ios={filterCircleOutline}
              md={filterCircleSharp}
            ></IonIcon>
          </IonItem>
          <IonRadioGroup
            value={selected}
            onIonChange={(e) => setSelected(e.detail.value)}
          >
            {(options ?? []).map((meta, index) => {
              const { Code, Description } = meta;
              return (
                <IonItem key={index}>
                  <IonLabel>
                    {Code} - {Description}
                  </IonLabel>
                  <IonRadio slot="start" value={Code} />
                </IonItem>
              );
            })}
          </IonRadioGroup>
        </IonContent>
        <IonFooter>
          <IonButton
            expand="block"
            onClick={(e) => {
              onSelect(selected);
              setShowEmployeeModal(false);
            }}
          >
            OK
          </IonButton>
          <IonButton
            fill="outline"
            expand="block"
            onClick={() => setShowEmployeeModal(false)}
          >
            Cancel
          </IonButton>
        </IonFooter>
      </IonModal>
    </React.Fragment>
  );
};

export default DropdownElement;
